import Button from 'src/components/common/button/button';

import IntroImage from '../../../../assets/images/quiz/take-command.svg';
import styles from './take-command.module.scss';

export const TakeCommand = ({ onChange }: { onChange: () => void }) => (
  <div className={styles.container}>
    <div className={styles.imageContainer}>
      <IntroImage />,
    </div>
    <footer className={styles.footer}>
      <h1 className={styles.title}>Take command of your life</h1>
      <p className={styles.text}>
        The Moon affects us every day. Reveal the secrets of its influence and
        learn how to control your life with Eclipse
      </p>
      <Button onClick={() => onChange()}>Find out how Moon affects me</Button>
    </footer>
  </div>
);
